/** Build-time configuration (VITE_* at build, see Dockerfile). */
const env = import.meta.env;

export const API_URL: string = (env.VITE_API_URL || 'http://localhost:8010').replace(/\/+$/, '');
export const BRAND: string = env.VITE_BRAND || 'VIA DOMUM';
/** `0.1.0+2026-10-20` — package.json version + build date (vite define). */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0+dev';
/** Optional link «Відкрити CRM». Empty — the link is hidden (or points to nothing on the non-partner screen). */
export const CRM_URL: string = (env.VITE_CRM_URL || '').replace(/\/+$/, '');

export const TOKEN_KEY = 'xq.partner.token';
export const LOCALE_KEY = 'xq.partner.locale';
export const SETTINGS_KEY = 'xq.partner.settings';
export const PENDING_KEY = 'xq.partner.pending-steps';

/** Photos are downscaled in the browser before upload: longest side ≤ this, JPEG. */
export const PHOTO_MAX_SIDE = 1600;
export const PHOTO_QUALITY = 0.82;
/** Translations are re-fetched this often (and when the tab becomes visible again). */
export const I18N_REFRESH_MS = 10 * 60 * 1000;
